import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';
import { Subject, Subscription, timer } from 'rxjs';
import { throttleTime as rxThrottleTime } from 'rxjs/operators';

@Directive({
    selector: '[appPreventDoubleClick]',
})
export class PreventDoubleClickDirective implements OnInit, OnDestroy {
    @Input() throttleTime = 3000;
    @Input() disableTime = 0;

    @Output()
    throttledClick = new EventEmitter<Event>();

    private clicks = new Subject<Event>();
    private subscription: Subscription;

    constructor(private el: ElementRef) {}

    ngOnInit() {
        this.subscription = this.clicks
            .pipe(rxThrottleTime(this.throttleTime))
            .subscribe((e) => this.emitThrottledClick(e));
    }

    emitThrottledClick(e: Event) {
        this.throttledClick.emit(e);

        if (this.disableTime > 0) {
            this.disableButton(this.disableTime);
        }
    }

    disableButton(seconds: number) {
        const button = this.el.nativeElement as HTMLElement;
        const originalText = button.textContent?.trim() ?? '';
        let remaining = seconds;

        button.setAttribute('disabled', 'true');
        (button as any).disabled = true;
        button.textContent = `${originalText} (${remaining})`;

        const interval = setInterval(() => {
            remaining--;
            if (remaining > 0) {
                button.textContent = `${originalText} (${remaining})`;
            } else {
                clearInterval(interval);
                (button as any).disabled = false;
                button.removeAttribute('disabled');
                button.textContent = originalText;
            }
        }, 1000);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    @HostListener('click', ['$event'])
    clickEvent(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        this.clicks.next(event);
    }
}
